<template>
  <div>
    <empty-state
      key="empty"
      :title="emptyStateInfo.title"
      :description="emptyStateInfo.description"
      class="m-auto flags-empty"
    >
      <template #buttons>
        <div class="d-flex justify-content-center flex-gap">
          <eg-button
            v-if="canGoAiDetector"
            type="primary"
            size="sm"
            @click="$emit('clickFlagsManually')"
          >
            {{ $t("essays.runManually") }}
          </eg-button>
          <div v-if="!premiumPlan">
            <eg-button
              :type="canGoAiDetector ? 'ordinary' : 'primary'"
              @click="upgradePlan"
            >
              {{
                canGoAiDetector
                  ? $t("essays.runAutomatically")
                  : $t("essays.upgradeSubscription")
              }}
            </eg-button>
            <eg-b-badge v-if="proPlan" pill variant="info-light">
              <eg-b-icon variant="info" icon="award" />
              {{ $t("account.premium") }}
            </eg-b-badge>
          </div>
        </div>
      </template>
    </empty-state>
  </div>
</template>

<script>
import EmptyState from "@/components/global/empty_state.vue";
import UpgradePlanModal from "@/components/global/modals/upgrade_plan_modal.vue";

export default {
  components: { EmptyState },

  inject: ["accountProvider"],

  props: {
    tab: {
      type: String,
      validator: (value) => {
        return ["plagiarism", "usedAI"].includes(value);
      },
      default: "usedAI",
    },
  },

  computed: {
    canGoAiDetector() {
      return this.$store.getters.userIsNotPausedAndPlanMoreThenPro;
    },

    emptyStateInfo() {
      switch (this.tab) {
        case "usedAI":
          return {
            title: this.$t("essays.aiDetectionInsights"),
            description: this.$t("essays.aiDetectionDescription"),
          };
        case "plagiarism":
          return {
            title: this.$t("essays.plagiarismCheck"),
            description: this.$t("essays.plagiarismDescription"),
          };
        default:
          return { title: "", description: "" };
      }
    },

    proPlan() {
      return this.$store.getters.proPlan;
    },
    premiumPlan() {
      return this.$store.getters.premiumPlan;
    },
  },

  methods: {
    upgradePlan() {
      this.$egModal.show("upgrade-plan-modal", {
        component: UpgradePlanModal,
        props: {
          currentPlan: this.accountProvider.subscription?.plan,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.flags-empty {
  height: calc(100vh - 350px);
}
</style>
